import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/esm/Button";
import { Link, Navigate, NavLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getLogin, getToken, logout } from "../../features/Loginuser";
import { AUTH_BASE_URL, BASE_URL } from "../../Config/Config";
import "../../css/common.css";
import "../../css/LoginComponent.css";
import Dropdown from "react-bootstrap/Dropdown";
import SmallLoader from "./SmallLoader";
import { Nav } from "react-bootstrap";
export default function LoginComponent() {
  const login = useSelector(getLogin);
  const token = useSelector(getToken);
  const [loading, setLoading] = useState(false);
  const [logoutall, setLogoutAll] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  function logoutUser() {
    setLoading(true);
    fetch(AUTH_BASE_URL + "/logout", {
      method: "POST",
      credentials: "include",
    }).then((response) => {
      if (response.ok) {
        setLoading(false);
        dispatch(logout());
      }
    });

    //Then with the data from the response in JSON...
  }
  useEffect(() => {
    if (!login) {
      navigate("/");
    }
  }, [login]);

  return (
    <>
      {login ? (
        <Nav>
          <NavLink
            className={({ isActive }) => (isActive ? "active" : " menutext")}
            to="/profilePage"
          >
            <i className="bi bi-person  me-2"></i>
            Profile
          </NavLink>
          <NavLink
            className={({ isActive }) => (isActive ? "active" : " menutext")}
            to="/change-password"
          >
            <i className="bi bi-key me-2"></i>
            Change Password
          </NavLink>

          <Button
            variant="light"
            className="m-2 menubutton"
            onClick={() => logoutUser()}
            disabled={logoutall}
          >
            {loading ? (
              <SmallLoader loadingtext={"Logging out..."} />
            ) : (
              "Logout"
            )}
          </Button>
        </Nav>
      ) : null}
    </>
  );
}
